import React, { useMemo, useState } from 'react';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import CreateWizard from 'feature/loading-management/carrier-authorizations/create-new-steps/CreateWizard';
import * as R from 'ramda';
import SummaryStep from 'common/SummaryStep';

const summaryVariation = {
  sections: [
    {
      rows: [
        { label: 'Affiliate', value: '410 PHILLIPS66' },
        { label: 'Carrier', value: 'THJL 3 J FUEL CARRIERS INC' },
      ],
      title: '1. Details',
    },
    {
      rows: [{ label: 'Locations', value: '2 selected' }],
      title: '2. Selection',
    },
  ],
  subtitleVariant: 'subtitle2',
  title: 'Compact Summary',
};

const DrawerComponentsPreview = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const steps = useMemo(
    () => [
      {
        component: (
          <SummaryStep
            headerTitle={summaryVariation.title}
            sections={summaryVariation.sections}
            subtitleVariant={summaryVariation.subtitleVariant}
          />
        ),
        disabled: R.F,
        hasChanges: R.F,
        id: 1,
        leftLabel: 'Cancel',
        loading: R.F,
        rightLabel: 'Continue',
        showSpinner: R.F,
        stepLabel: R.always('Summary Step'),
      },
    ],
    []
  );

  return (
    <>
      <h1>Drawer Components Preview</h1>
      <Button onClick={handleOpenDrawer} variant="contained">
        Open Drawer
      </Button>
      <Drawer
        anchor="right"
        onClose={handleCloseDrawer}
        open={isDrawerOpen}
        PaperProps={{ sx: { overflowY: 'revert', width: { sm: 390, xs: '100%' } } }}
      >
        <CreateWizard
          onClose={handleCloseDrawer}
          steps={steps}
          title="New Carrier Authorizations"
        />
      </Drawer>
    </>
  );
};

export default DrawerComponentsPreview;
